const AdminCandidateCertificationProject = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/candidateDetails/AdminCandidateProjectCertif.vue"
  );
const AdminCandidateProfile = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/candidateDetails/AdminCandidateProfile.vue"
  );
const AdminCandidateDocuments = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/candidateDetails/AdminCandidateDocuments.vue"
  );
const AdminCandidateTransferredDocuments = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/candidateDetails/AdminCandidateTransferredDocuments.vue"
  );

export default [
  {
    path: ":userId/certification-project",
    name: "admin-candidates-certification-project",
    component: AdminCandidateCertificationProject,
  },
  {
    path: ":userId/profile",
    name: "admin-candidates-profile",
    component: AdminCandidateProfile,
  },
  {
    path: ":userId/documents",
    name: "admin-candidates-documents",
    component: AdminCandidateDocuments,
  },
  {
    path: ":userId/transferred-documents",
    name: "admin-candidates-transferred-documents",
    component: AdminCandidateTransferredDocuments,
  },
];
